import { createAction, props } from '@ngrx/store';
export const setDataSource = createAction('[Custom PDF Report Builder] Set Data Source', props());
